import {
  Alert,
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import { useEffect, useState } from 'react';
import FileValidation from '../../../../../Components/FileValidation/FileValidation';
import { useWatch } from 'react-hook-form';

const areAllFieldsFilled = (values: Partial<FormData>) => {
  return Object.values(values).every(
    (value: any) => value !== null && value !== undefined && value !== '',
  );
};
const CommonOfflinePaymentInfo = ({
  register,
  errors,
  clearErrors,
  setError,
  setValue,
  sm,
  md,
  lg,
  setPaymentOfflineInformation,
  control,
  onlinePaymentAmount,
}: {
  register: any;
  errors: any;
  clearErrors: any;
  setError: any;
  setValue?: any;
  sm?: number;
  md?: number;
  lg?: number;
  setPaymentOfflineInformation?: React.Dispatch<any>;
  control?: any;
  onlinePaymentAmount?: number;
}) => {
  const [showRequredMessage, setShowRequredMessage] = useState<string | null>(
    null,
  );
  const allValue = useWatch(control ? { control } : {});
  const [paymentType, setPaymentType] = useState(allValue?.type || 'online');
  const areFieldsValid = areAllFieldsFilled(allValue);

  useEffect(() => {
    if (allValue?.type) {
      setPaymentType(allValue.type);
    }
  }, [allValue?.type]);

  useEffect(() => {
    if ((allValue?.type || paymentType) === 'online') {
      setPaymentOfflineInformation?.({
        type: 'online',
      });

      return;
    }

    setPaymentOfflineInformation?.(allValue);

    if (areFieldsValid) {
      setShowRequredMessage(null);
    } else {
      setShowRequredMessage(
        'All fields are mandatory. Please fill up all fields.',
      );
    }
  }, [areFieldsValid, allValue, paymentType]);

  const handleTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setPaymentType(val);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl component='fieldset'>
            <FormLabel component='legend' sx={{ fontWeight: 'bold', mb: 1 }}>
              Select Payment Option
            </FormLabel>
            <RadioGroup row value={paymentType} onChange={handleTypeChange}>
              <FormControlLabel
                value='online'
                control={<Radio {...register('type')} />}
                label='Online Payment'
              />

              <FormControlLabel
                value='offline'
                control={<Radio {...register('type')} />}
                label='Offline Payment'
              />
            </RadioGroup>
          </FormControl>

          {paymentType === 'offline' && (
            <Box
              sx={{
                color: 'red',
              }}
            >
              {showRequredMessage && <span>{showRequredMessage}</span>}
            </Box>
          )}
        </Grid>

        {paymentType === 'online' ? (
          <Grid item xs={12}>
            <Alert
              severity='info'
              sx={{ fontSize: '0.95rem', fontWeight: 500, color: '#124d9a' }}
            >
              You have selected <strong>Online Payment</strong>. Total Amount:{' '}
              <strong style={{ fontSize: '1.05rem', color: '#124d9a', backgroundColor: 'rgba(18, 77, 154, 0.08)', padding: '2px 8px', borderRadius: '4px', margin: '0 4px', display: 'inline-block' }}>
                ৳ {onlinePaymentAmount ? Number(onlinePaymentAmount).toLocaleString() : '00'}
              </strong>.
              Please click the <strong>Submit</strong> button below to proceed with your payment.
            </Alert>
          </Grid>
        ) : (
          <>
            <Grid item xs={12} sm={sm || 6} md={md || 6} lg={lg || 6}>
              <TextField
                fullWidth
                disabled
                InputLabelProps={{ shrink: true }}
                value={'Association of Travel Agents of Bangladesh'}
                label='Payorder in Favor of'
                variant='outlined'
              />
            </Grid>

            <Grid item xs={12} sm={sm || 6} md={md || 6} lg={lg || 6} hidden>
              <TextField
                {...register('bank_ac_no', {
                  // required: 'Account No is required',
                })}
                fullWidth
                disabled
                InputLabelProps={{ shrink: true }}
                value={'00890320000141'}
                label='Account No'
                variant='outlined'
                error={!!errors.bank_ac_no}
                helperText={errors.bank_ac_no?.message}
              />
            </Grid>

            <Grid item xs={12} sm={sm || 6} md={md || 6} lg={lg || 6}>
              <TextField
                {...register('deposit_date', {
                  required: 'Deposit Date is required',
                })}
                fullWidth
                label={
                  <>
                    Deposit Date <span style={{ color: 'red' }}>*</span>
                  </>
                }
                variant='outlined'
                type='date'
                InputLabelProps={{ shrink: true }}
                error={!!errors?.deposit_date}
                helperText={errors?.deposit_date?.message}
              />
            </Grid>
            <Grid item xs={12} sm={sm || 6} md={md || 6} lg={lg || 6} hidden>
              <TextField
                {...register('bank_name', {
                  // required: 'Bank Name is required',
                })}
                disabled
                defaultValue={'Trust Bank'}
                fullWidth
                value={'Trust Bank  (Kakrail Branch)'}
                label='Bank Name'
                variant='outlined'
                error={!!errors?.bank_name}
                helperText={errors?.bank_name?.message}
              />
            </Grid>

            <Grid item xs={12} sm={sm || 6} md={md || 6} lg={lg || 6}>
              <TextField
                {...register('branch_name', {
                  required: 'Bank & Branch Name is required',
                })}
                label={
                  <>
                    Bank & Branch Name <span style={{ color: 'red' }}>*</span>
                  </>
                }
                fullWidth
                variant='outlined'
                error={!!errors?.branch_name}
                helperText={errors?.branch_name?.message}
              />
            </Grid>
            <Grid item xs={12} sm={sm || 6} md={md || 6} lg={lg || 6}>
              <TextField
                {...register('amount', {
                  required: 'Amount is required',
                  min: { value: 1, message: 'Amount must be greater than 0' },
                })}
                disabled
                fullWidth
                InputLabelProps={{ shrink: true }}
                label='Amount'
                variant='outlined'
                type='number'
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>৳</InputAdornment>
                  ),
                }}
                error={!!errors.amount}
                helperText={errors.amount?.message}
              />
            </Grid>

            <Grid item xs={12} sm={sm || 6} md={md || 6} lg={lg || 6}>
              <FileValidation
                mt='0'
                fileLimitSize={3}
                isRequired
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Upload Pay Order/Bank Deposit Slip/Cheque ( max size 3mb )'
                fieldName={`bank_slip`}
                // onChange={(e: any) => {
                //   handleChangeInput(index, 'company_owner_photo', e);
                // }}

                hideCustomLabel
              />
            </Grid>
            <Grid item xs={12} sm={sm || 6} md={md || 6} lg={lg || 6}>
              <TextField
                {...register('reference_no', {
                  required: 'PO No/Cq No/Deposit Slip No is required',
                })}
                fullWidth
                label='PO No/Cq No/Deposit Slip No'
                variant='outlined'
                error={!!errors?.reference_no}
                helperText={errors?.reference_no?.message}
              />
            </Grid>
            {/* <Grid item xs={12} display={'flex'} justifyContent={'end'}>
                <Button variant='contained' color='primary' type='submit'>
                  Save
                </Button>
              </Grid> */}
          </>
        )}
      </Grid>
    </>
  );
};

export default CommonOfflinePaymentInfo;
